import { api } from 'utils/apis/api';
export const twitterApi = api
    .enhanceEndpoints({
    addTagTypes: ['TwitterAccounts'],
})
    .injectEndpoints({
    endpoints: (builder) => ({
        readConnectToken: builder.query({
            query: () => ({
                version: 1,
                path: 'twitter/request_token',
            }),
        }),
        createAccount: builder.mutation({
            query: ({ auth_token, auth_token_secret, verifier, queueId: queue_id, }) => ({
                version: 1,
                path: `twitter/accounts/connect`,
                body: { auth_token, auth_token_secret, verifier, queue_id },
            }),
            invalidatesTags: [{ type: 'TwitterAccounts', id: 'LIST' }],
        }),
        updateAccount: builder.mutation({
            query: ({ alias_name, queue_id, account_id }) => ({
                version: 1,
                path: `twitter/accounts/${account_id}`,
                method: 'PATCH',
                body: {
                    alias_name,
                    queue_id,
                },
            }),
            invalidatesTags: [{ type: 'TwitterAccounts', id: 'LIST' }],
        }),
        deleteAccount: builder.mutation({
            query: (accountId) => ({
                version: 1,
                path: `twitter/accounts/${accountId}`,
            }),
            invalidatesTags: [{ type: 'TwitterAccounts', id: 'LIST' }],
        }),
        readAccounts: builder.query({
            query: () => ({
                version: 1,
                path: `twitter/accounts`,
            }),
            providesTags: [{ type: 'TwitterAccounts', id: 'LIST' }],
        }),
    }),
});
